/* eslint-disable*/
import { ArrowBack } from "@mui/icons-material";
import { PageNavigation } from "@/Components/Headers/PageNavigation";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { RefreshCcw } from "lucide-react";
import { Tooltip } from "@mui/material";

function GrnHeader(props) {
    const {url, title='', navigatePrevToolTip = '',navigateLabel='',navigateNextToolTip='', navigateQC, idx, listData, id, isRefresh = false, handleRefresh= () => {}} = props;
    const history = useHistory();
    const handleBack = () => {
        history.push(url);
    }

    return (
        <div className="flex justify-between items-center px-6 py-3 border-b border-gray-200 fixed left-0 right-0 top-13 bg-white z-[999] shadow-sm">
            <div className="flex items-center gap-2 relative left-[16rem]">
                <ArrowBack onClick={handleBack} className="cursor-pointer" />
                <p className="text-base font-medium">{title}</p>
            </div>
            <div className="flex items-center gap-2">
                {isRefresh && (
                    <Tooltip title="Refresh For Latest Data">
                        <RefreshCcw onClick={handleRefresh} className="cursor-pointer" size={16} />
                    </Tooltip>
                 )}
                <PageNavigation
                    navigate={navigateQC}
                    prev={{
                        tooltip: navigatePrevToolTip,
                        show: idx > 0,
                        disabled: idx === 0,
                    }}
                    current={{
                        label: navigateLabel,
                        value: id,
                    }}
                    next={{
                        tooltip: navigateNextToolTip,
                        show: idx >= 0 && idx < listData?.length - 1,
                        disabled: idx < 0 || idx === listData?.length - 1,
                    }}
                />
            </div>
        </div>
    );
}

export default GrnHeader;

